module.exports = __webpack_public_path__ + "static/media/NICE_Step2a_Image2g.bb1546ea.jpg";